import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map, Observable } from 'rxjs';
import { apiList, getApiUrl } from 'src/app/core/Constants/apiList';
import { ApiResponse } from 'src/app/core/Models/interfaces/responseData'
import { UserService } from 'src/app/core/Services/user.service';

@Injectable({
  providedIn: 'root'
})
export class LoginApiService {

  constructor(private http: HttpClient,
    private userService: UserService,
    private router: Router) { }

  public userLogin(data: { password: string, userType: number, username: string }): Observable<ApiResponse> {
    let endpoint = getApiUrl(apiList.login.userLogin);
    return this.http.post<ApiResponse>(endpoint, data)
  }

  public userLogout(): Observable<ApiResponse> {
    let endpoint = getApiUrl(apiList.logOut.logout);
    return this.http.get<ApiResponse>(endpoint).pipe(
      map(res => {
        if (res) {
          localStorage.clear();
          sessionStorage.clear();
          this.userService.userProfile = null;
          this.router.navigate(['./login/user-login']);
        }
        return res;
      })
    );
  }

  public forgot(data: { userName: string }): Observable<ApiResponse> {
    let endpoint = getApiUrl(apiList.login.forgotPassword);
    return this.http.post<ApiResponse>(endpoint, data)
  }
}
